/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rate_Prompt_High_ThanksInputs */

const en_rate_prompt_high_thanks = /** @type {(inputs: Rate_Prompt_High_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awesome, thank you! Would you mind rating us on the Chrome Web Store?`)
};

const es_rate_prompt_high_thanks = /** @type {(inputs: Rate_Prompt_High_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Genial, gracias! ¿Nos calificarías en Chrome Web Store?`)
};

/**
* | output |
* | --- |
* | "Awesome, thank you! Would you mind rating us on the Chrome Web Store?" |
*
* @param {Rate_Prompt_High_ThanksInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const rate_prompt_high_thanks = /** @type {((inputs?: Rate_Prompt_High_ThanksInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rate_Prompt_High_ThanksInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_rate_prompt_high_thanks(inputs)
	return en_rate_prompt_high_thanks(inputs)
});